import React from "react";
import { Link } from "react-router-dom";
import Text from "../Text/Text";
import "./NavMenuItem.css";
import classNames from "classnames";

type NavMenuItemProps = {
  label: string;
  link: string;
  isDisabled?: boolean;
  isActive: boolean;
  icon: React.ReactNode;
};
const NavMenuItem = React.memo(
  ({ label, link, isDisabled, isActive, icon }: NavMenuItemProps) => {
    return (
      <Link
        to={link}
        className={classNames("NavMenuItem", {
          "NavMenuItem--active": isActive,
          "NavMenuItem--disabled": isDisabled,
        })}
      >
        <i
          className={classNames("NavMenuItem__icon", {
            "NavMenuItem__icon--active": isActive,
            "NavMenuItem__icon--disabled": isDisabled,
          })}
        >
          {icon}
        </i>
        <Text
          type="default"
          size={3}
          className={classNames("NavMenuItem__label", {
            "NavMenuItem__label--disabled": isDisabled,
          })}
        >
          {label}
        </Text>
      </Link>
    );
  }
);

export default NavMenuItem;
